/**
 * MetricSelector component barrel export
 *
 * Dropdown selector for changing chart metrics.
 */

export { default } from "./MetricSelectorContainer";
